"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// eslint-disable-next-line react/prop-types
var Alert = function Alert(_ref) {
  var message = _ref.message,
      onDismiss = _ref.onDismiss;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: '100px',
      zIndex: 9999
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: 'rgb(253, 236, 234)',
      padding: '6px 16px',
      display: 'flex',
      color: 'rgb(97, 26, 21)',
      borderRadius: 4,
      boxShadow: '0px 3px 1px -2px rgb(120 128 137 / 20%), 0px 2px 2px rgb(120 128 137 / 14%), 0px 1px 5px rgb(120 128 137 / 12%)'
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    style: {
      background: 'none',
      color: 'inherit',
      border: 'none',
      padding: 6,
      font: 'inherit',
      cursor: 'pointer',
      outline: 'inherit',
      fontSize: 16,
      fontWeight: 'bold',
      marginLeft: 24
    },
    onClick: onDismiss
  }, "X")));
};

var _default = Alert;
exports["default"] = _default;